export default "__VITE_ASSET__D4g4QNqY__"